module.exports = __webpack_public_path__ + "img/img_mask.d12af496.png";